"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SNETTextfield = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _HelpOutline = _interopRequireDefault(require("@mui/icons-material/HelpOutline"));
var _clsx = _interopRequireDefault(require("clsx"));
var _SNETTextfieldModule = _interopRequireDefault(require("./SNETTextfield.module.css"));
var _StyledTextField = _interopRequireDefault(require("../StyledTextField"));
var _AlertText = _interopRequireDefault(require("../../feedback/AlertText"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const FormedTooltipText = _ref => {
  let {
    classes,
    infoMsg,
    label
  } = _ref;
  return infoMsg ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    placement: "top-start",
    title: /*#__PURE__*/_react.default.createElement("span", {
      className: classes.textAreaTooltip
    }, (0, _htmlReactParser.default)(infoMsg))
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.textAreaLabel
  }, /*#__PURE__*/_react.default.createElement("span", null, label), /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null))) : /*#__PURE__*/_react.default.createElement("span", null, label);
};
const SNETTextfield = _ref2 => {
  let {
    name,
    label,
    helperText,
    value,
    onChange,
    maxCount,
    disabled,
    disabledAll,
    description,
    infoMsg,
    onKeyUp,
    extraInfo,
    inputRef,
    InputProps,
    error,
    ...rest
  } = _ref2;
  disabled = disabled || disabledAll;
  const DescriptionComponent = _ref3 => {
    let {
      disabledAll
    } = _ref3;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(_SNETTextfieldModule.default.description, disabledAll && _SNETTextfieldModule.default.disabled)
    }, description);
  };
  const CountCharComponent = () => {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: _SNETTextfieldModule.default.charLength
    }, value.length, "/", maxCount, " char");
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(error ? _SNETTextfieldModule.default.errorField : "", _SNETTextfieldModule.default.textFieldContainer)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETTextfieldModule.default.basicTextFieldGrid
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETTextfieldModule.default.textFieldWithExtraText
  }, /*#__PURE__*/_react.default.createElement(_StyledTextField.default, _extends({
    name: name,
    label: /*#__PURE__*/_react.default.createElement(FormedTooltipText, {
      classes: _SNETTextfieldModule.default,
      infoMsg: infoMsg,
      label: label
    }),
    helperText: helperText,
    variant: "outlined",
    value: value,
    onChange: onChange,
    fullWidth: true,
    onKeyUp: onKeyUp,
    disabled: disabled,
    inputRef: inputRef,
    InputProps: InputProps
  }, rest)), error && /*#__PURE__*/_react.default.createElement(_AlertText.default, {
    type: error.type,
    message: error.message
  }), maxCount && /*#__PURE__*/_react.default.createElement(CountCharComponent, null), extraInfo && /*#__PURE__*/_react.default.createElement("span", {
    className: _SNETTextfieldModule.default.extraInfo
  }, extraInfo))), description && /*#__PURE__*/_react.default.createElement(DescriptionComponent, {
    disabledAll: disabledAll
  }));
};
exports.SNETTextfield = SNETTextfield;
SNETTextfield.propTypes = {
  name: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  helperText: _propTypes.default.string,
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  onChange: _propTypes.default.func
};
var _default = exports.default = SNETTextfield;